/**
 * A customer's own account data: the profile and the saved addresses. The
 * email is shown but stays as it is; changing it would need a verification
 * the shop does not have.
 */
import { z } from "zod";
import { Contact, ShippingAddress } from "./checkout.js";
import { OptionalText } from "./reviews.js";
export const AddressId = {
    schema: z.uuid().brand(),
};
export const ProfileInput = {
    schema: z.strictObject({
        fullName: OptionalText.of(100, "Use at most 100 characters.").pipe(z.string().min(2, "Enter at least 2 characters.").optional()),
        phone: z
            .string()
            .trim()
            .transform((phone) => (phone.length === 0 ? undefined : phone))
            .pipe(Contact.schema.shape.phone.optional())
            .optional(),
    }),
};
export const SavedAddressInput = {
    schema: z.strictObject({
        /** What the customer calls it, such as "Home". */
        label: z.string({ error: "Name the address." }).trim().min(1, "Name the address.").max(40, "Use at most 40 characters."),
        fullName: Contact.schema.shape.fullName,
        phone: Contact.schema.shape.phone,
        address: ShippingAddress.schema,
        /** Makes this the address checkout starts with. */
        isDefault: z.boolean().default(false),
    }),
};
export const SavedAddress = {
    /** The most addresses one account keeps. */
    MAX: 10,
};
//# sourceMappingURL=account.js.map